import React from "react";
import Modal from "react-modal";
import "./Error.css";
import { useTranslation } from "react-i18next";

Modal.setAppElement("#root");

/* Modale d'erreur globale — design "Signal" */
const Error = (props) => {
  const { showErrorModal, setShowErrorModal, errorMsg } = props;
  const { t } = useTranslation();

  if (!showErrorModal) return null;

  return (
    <Modal
      isOpen={showErrorModal}
      onRequestClose={() => setShowErrorModal(false)}
      className="auth-modal"
      contentLabel={t("overview.error")}
    >
      <div className="auth-card">
        <div className="auth-card__head">
          <h1 className="auth-card__title" style={{ color: "var(--color-danger)" }}>
            {t("overview.error")}
          </h1>
          <button
            type="button"
            className="auth-card__close"
            onClick={() => setShowErrorModal(false)}
            aria-label={t("signal.close")}
          >
            ✕
          </button>
        </div>
        <p className="auth-card__error">{errorMsg}</p>
        <button
          className="sg-btn sg-btn--ghost sg-btn--sm"
          onClick={() => setShowErrorModal(false)}
          style={{ alignSelf: "flex-end" }}
        >
          {t("signal.close")}
        </button>
      </div>
    </Modal>
  );
};

export default Error;
